import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { VStack, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

import FiltersGrid from "../components/filters_grid";
import TableData from "../components/staff_page/table_data";

const StaffPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllDepartments();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPeriod("");
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/staff");
  }, []);

  useEffect(() => {
    pageStore.resetFilters();
  }, [])

  console.log("email", pageStore.email);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid
          page="staff"
          renderButtons={(buttons) => buttons}
        />

        <TableData
          data={pageStore?.data_staff}
          renderButtons={(buttons) => buttons}
        />
      </HStack>
    </VStack>
  );
});

export default StaffPage;
